import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getMasterProducts = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(
    `v1/master-product?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getMasterProduct = async (id: string) => {
  return await customFetch(`v1/master-product/${id}`, {
    method: "GET",
  });
};

export const createMasterProduct = async (data: any) => {
  return await customFetch("v1/master-product", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateMasterProduct = async (id: string, data: any) => {
  return await customFetch(`v1/master-product/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteMasterProduct = async (id: string) => {
  return await customFetch(`v1/master-product/${id}`, {
    method: "DELETE",
  });
};

export const convertToProducts = async (ids: string[]) => {
  return await customFetch(`v1/master-product/convert-to-product`, {
    method: "POST",
    body: JSON.stringify(ids),
  });
};


export const addPriceMasterProduct = async (id: string, data: any) => {
  data.master_product_id = data.product_id;
  delete data.product_id;
  return await customFetch(`v1/master-product/${id}/price`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteMasterProductImage = async (id: string, imageId: string) => {
  return await customFetch(
    `v1/master-product/${id}/image/${imageId}`,
    {
      method: "DELETE",
    }
  );
};

export const deleteMasterProductPrice = async (id: string, priceId: string) => {
  return await customFetch(`v1/master-product/${id}/price/${priceId}`, {
    method: "DELETE",
  });
};
